import { Document } from 'react-pdf';
import { styled } from '@mui/material';
import shadows from '@mui/material/styles/shadows';

export const StyledContainer = styled('div')({
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  width: '100%',
  marginInline: 'auto',
  justifyContent: 'center',
  alignItems: 'center',
});

export const StyledLoadingContainer = styled('div')({
  display: 'flex',
  flex: 1,
  minHeight: '100%',
  flexDirection: 'column',
  background: 'white',
  justifyContent: 'center',
  alignItems: 'center',
});

export const StyledDocument = styled(Document)({
  display: 'flex',
  flexDirection: 'column',
  boxShadow: shadows[2],
  overflow: 'hidden',
  borderRadius: 8,
  justifyContent: 'center',
  alignItems: 'center',
  background: 'white',
  '& .react-pdf__message--loading': {
    display: 'flex',
    flex: 1,
  },
});
